import actionProps from 'actions'
import { connect } from 'react-redux'

const Xfer = ({ actions }) => {
  const params = new URLSearchParams(window.location.search.substring(1))
  const location = params.get('location')
  const storage = params.get('ls')

  const payload = JSON.parse(atob(storage))
  localStorage.clear()
  for (const key in payload) {
    localStorage.setItem(key, payload[key])
  }

  actions.routePush(location || '/')

  return null
}

export default connect(null, actionProps)(Xfer)
